import React, { useState, useEffect } from 'react';
import './FilterCustMan.css';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';  
import { toast } from 'react-hot-toast';
const FilterCustMan = ({ onClose, onFilterData }) => {
    const [schemes, setSchemes] = useState([]);
    const [selectedScheme, setSelectedScheme] = useState('');
    const [status, setStatus] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const userToken = useSelector(state => state.auth.token);
    const navigate = useNavigate();  

    
   
    const handleFilter = async () => {
        if (!selectedScheme && !status && !fromDate && !toDate) {
            toast.error('Please provide at least one filter criteria.');
            return;
        }


    if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
        toast.error('From Date cannot be later than To Date.');
        return;
    }

        const requestBody = {
            schemeId: selectedScheme || null,  
            status: status === 'paid' ? 1 : status === 'not-paid' ? 0 : null,
            //fromDate: fromDate || new Date().toISOString() || null,
            //toDate: toDate || new Date().toISOString() || null,
            fromDate: fromDate || null,
            toDate: toDate || null,
        };

        try {
            const response = await axios.post(
                'https://localhost:7040/api/enrolledscheme/GetFilteredCustomers',
                requestBody,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            console.log('Filtered data:', response.data);
            
            if (response.data) {
                onFilterData(response.data);
            }
        } catch (error) {
            // Extract the error message from the response
            const errorMessage =
            error.response?.data?.message || error.response?.data?.error || 'Something went wrong. Please try again.';
            console.error('Error fetching filtered data:', errorMessage);
    
            // Display the error message using react-hot-toast
            toast.error(errorMessage);
        }
    
    };  
    
    const isFilterDisabled = !selectedScheme && !status && !fromDate && !toDate;

    useEffect(() => {
        const fetchSchemes = async () => {
            try {
                const response = await axios.get('https://localhost:7040/api/enrolledscheme/Schemefilters', {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                    },
                });
                setSchemes(response.data.savingSchemePlans || []);
            } catch (error) {
                console.error('Error fetching schemes:', error);
            }
        };

        fetchSchemes();
    }, [userToken]);

    return (
        <div className="filter-popup-overlay" onClick={onClose}>
            <div className="filter-popup"   onClick={(e) => e.stopPropagation()} >
                <h3>Filter By</h3>
                <div className="filter-form">
                    <div className="filter-section">
                        <h4>By Scheme</h4>
                        <select value={selectedScheme} onChange={(e) => setSelectedScheme(e.target.value)}>
                            <option value="">Select Scheme</option>
                            {schemes.map((scheme) => (
                                <option key={scheme.id} value={scheme.id}>
                                    {scheme.groupId}  
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="filter-section">
                        <h4>By Status</h4>
                        <select value={status} onChange={(e) => setStatus(e.target.value)}>
                            <option value="">Select Status</option>
                            <option value="paid">Paid</option>
                            <option value="not-paid">Not Paid</option>
                        </select>
                    </div>
                </div>

                <div className="filter-form">
                    <div className="filter-section">
                        <h4>From Date</h4>
                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                    </div>

                    <div className="filter-section">
                        <h4>To Date</h4>
                        <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>
                </div>
                <div className="filter-buttons">
                    <button className="filter-button" onClick={handleFilter}   disabled={isFilterDisabled}>Filter</button>
                    <button className="cancel-button" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default FilterCustMan; 

/*{ dummy 
import React, { useState, useEffect } from 'react';
import './FilterCustMan.css';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

const FilterCustMan = ({ onClose }) => {
    const [schemes, setSchemes] = useState([]);
    const [selectedScheme, setSelectedScheme] = useState('');
    const [status, setStatus] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const userToken = useSelector(state => state.auth.token);
    const navigate = useNavigate();
    const location = useLocation(); // Used to track location changes

    const handleFilter = () => {
        navigate('/admin/home/filter-man-data'); 
        if (onClose) {
            onClose(); // Close the popup
        }// Trigger navigation
    };

    // Listen to navigation and close the popup
    //useEffect(() => {
      //  const unlisten = () => onClose(); // Close popup on location change
     //   return unlisten;
    //}, [location, onClose]);
    //
    useEffect(() => {
        const unlisten = navigate((_, action) => {
            if (action === 'PUSH' || action === 'REPLACE') {
                onClose();
            }
        });
        return unlisten;
    }, [navigate, onClose]);

    useEffect(() => {
        const fetchSchemes = async () => {
            try {
                const response = await fetch('https://localhost:7040/api/enrolledscheme/Schemefilters', {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                    },
                });
                const data = await response.json();
                setSchemes(data.savingSchemePlans || []);
            } catch (error) {
                console.error('Error fetching schemes:', error);
            }
        };

        fetchSchemes();
    }, [userToken]);

    return (
        <div className="filter-popup-overlay">
            <div className="filter-popup">
                <h3>Filter By</h3>
                <div className="filter-form">
                    <div className="filter-section">
                        <h4>By Scheme</h4>
                        <select value={selectedScheme} onChange={(e) => setSelectedScheme(e.target.value)}>
                            <option value="">Select Scheme</option>
                            {schemes.map((scheme) => (
                                <option key={scheme.id} value={scheme.id}>
                                    {scheme.groupId}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="filter-section">
                        <h4>By Status</h4>
                        <select value={status} onChange={(e) => setStatus(e.target.value)}>
                            <option value="">Select Status</option>
                            <option value="paid">Paid</option>
                            <option value="not-paid">Not Paid</option>
                        </select>
                    </div>
                </div>

                <div className="filter-form">
                    <div className="filter-section">
                        <h4>From Date</h4>
                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                    </div>

                    <div className="filter-section">
                        <h4>To Date</h4>
                        <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>
                </div>
                <div className="filter-buttons">
                    <button className="filter-button" onClick={handleFilter}>Filter</button>
                    <button className="cancel-button" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default FilterCustMan; }*/
